module.exports = {"PayRaja":"पेराजा","Earn Money as a UPI Agent":"UPI एजेंट के रूप में पैसे कमाएँ!","Download APK":"APK डाउनलोड करें","Become a UPI Payment Agent & Start Earning!":"UPI भुगतान एजेंट बनें और कमाई शुरू करें!","Order Amount":"आदेश राशि","Bonus":"बोनस","You Can Earn":"आप कमा सकते हैं","Download to Earn Money Now":"अब डाउनलोड करके पैसे कमाएँ","HELP":"मदद"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/hi.json
// module id = y92X
// module chunks = 2